import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { orderFulfillPaymentQuery } from '../../../graphql'
import { CashPartial } from './CashPartial'
import { useContext } from './Context'
import { PaymentMethodEnum } from '@ztechapps/common.contract'
import { DataSuspense } from '@ztechapps/webui.util'
import { InlineDisplayContent, TextAreaInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'
import { formatMoney } from '@ztechapps/common.utils'
import { useMutation } from '@ztechapps/common.hook'
import { Stack } from 'react-bootstrap'
import { useCheckoutContext } from '../../../index'

export const Layout = ({ onPay }: { onPay?: any }) => {
  const context = useCheckoutContext()

  const fromCheckout = context.fromCheckout

  const onSuccess = async () => {
    await context?.onSuccess?.()
  }
  const { document } = context.orderDocumentResult
  const { amount, errors } = useContext()

  const [remarks, setRemarks] = React.useState('')
  const [fulfill, , { loading, error }] = useMutation({ query: orderFulfillPaymentQuery })
  const hasError = !isEmpty(errors)

  onPay =
    onPay?.({ orderNetAmount: amount, remarks, hasError }) ??
    (async () => {
      if (hasError) return

      const orderId = document?._id

      await fulfill({
        input: {
          _id: orderId,
          orderId,
          fulfilledVia: 'Cash',
          paymentMethod: PaymentMethodEnum.cash,
          remarks,
          paymentNet: amount,
          paymentGross: amount,
          fromCheckout,
        },
      })

      await onSuccess()
    })

  return (
    <DataSuspense {...{ error, loading }}>
      <p>
        Add the payment for this order as paid in Cash or any other method that cannot be captured by our Stripe payment
        processor.
      </p>

      <Stack gap={2}>
        <CashPartial />

        <InlineDisplayContent label="Remarks" help="Enter some remarks about this payment.">
          <TextAreaInput onChange={(e) => setRemarks(e?.target?.value)} value={remarks} />
        </InlineDisplayContent>

        <div>
          <BusyButton
            bsStyle="primary"
            text={`Pay ${formatMoney(amount)} in Cash`}
            isBusy={loading}
            onClick={onPay}
            disabled={hasError}
          />
        </div>
      </Stack>
    </DataSuspense>
  )
}
